import { render, staticRenderFns } from "./GSTconfirmLoadsForm.vue?vue&type=template&id=0d40b0ac&scoped=true"
import script from "./GSTconfirmLoadsForm.vue?vue&type=script&lang=js"
export * from "./GSTconfirmLoadsForm.vue?vue&type=script&lang=js"
import style0 from "./GSTconfirmLoadsForm.vue?vue&type=style&index=0&id=0d40b0ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d40b0ac",
  null
  
)

export default component.exports